module.exports = __webpack_public_path__ + "img/evaluate_02.5dbec52f.png";